import { defineComponent, PropType } from "vue";
import eventBus from "../../../../../utilities/eventBus";

export default defineComponent({
    name: "MessageHoverActions",

    props: {
        messageId: {
            type: String,
            required: true
        },
        openDelay: {
            type: Number,
            default: 500
        },
        position: {
            type: String as PropType<"left" | "right">,
            default: "right"
        }
    },
    emits: ["hover-closed"],

    data() {
        return {
            isVisible: false as boolean,
            hoverTimer: null as ReturnType<typeof setTimeout> | null,
            isTouchDevice: false as boolean
        };
    },

    mounted() {
        eventBus.on("hoverOpen", this.onOtherHoverOpen);
        document.addEventListener("click", this.onOutsideClick);
    },

    beforeUnmount() {
        eventBus.off("hoverOpen", this.onOtherHoverOpen);
        document.removeEventListener("click", this.onOutsideClick);
    },

    methods: {
        /* -----------------------
         * helpers
         * --------------------- */
        clearTimer() {
            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer);
                this.hoverTimer = null;
            }
        },

        open() {
            eventBus.emit("hoverOpen", this.messageId);
            this.isVisible = true;
        },

        close() {
            this.clearTimer();
            if (this.isVisible) {
                this.isVisible = false;
                this.$emit("hover-closed");
            }
        },

        /* -----------------------
         * desktop hover
         * --------------------- */
        onMouseEnter() {
            if (this.isTouchDevice || this.hoverTimer) return;

            this.hoverTimer = setTimeout(() => {
                this.open();
                this.hoverTimer = null;
            }, this.openDelay);
        },

        onMouseLeave() {
            this.clearTimer();
        },

        /* -----------------------
         * mobile long press
         * --------------------- */
        onTouchStart() {
            this.isTouchDevice = true;

            this.hoverTimer = setTimeout(() => {
                this.open();
                this.hoverTimer = null;
            }, this.openDelay);
        },

        onTouchEnd() {
            this.clearTimer();
        },

        onTouchCancel() {
            this.clearTimer();
        },

        /* -----------------------
         * coordination + outside click
         * --------------------- */
        onOtherHoverOpen(id: string | number) {
            if (id !== this.messageId) {
                this.close();
            }
        },

        onOutsideClick(event: MouseEvent) {
            const wrapper = this.$refs.wrapper as HTMLElement;
            if (!wrapper) return;

            if (!wrapper.contains(event.target as Node)) {
                this.close();
            }
        }
    }
});
